import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheck,
    faComment,
    faRotateLeft,
    faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { Stars } from "./Stars";
import "./JobApplicationsManager.css";

const STATUS_BADGE_CLASS = {
    pending: "badge_pending",
    confirmed: "badge_confirmed",
    rejected: "badge_rejected",
    withdrawn: "badge_rejected",
};

export const JobApplicationsManager = ({
    positions = [],
    onStatusChange,
    onOpenChat,
}) => {
    return (
        <div className="job_applications_manager">
            <h3 className="manager_title">Správa uchazečů a směn</h3>

            {positions.map((position) => {
                const posApplications = position.applications || [];
                const confirmedCount = posApplications.filter(
                    (app) =>
                        app.status === "confirmed" || app.status === "accepted",
                ).length;
                const isFull =
                    position.confirmed_count !== undefined
                        ? position.confirmed_count >= position.required_count
                        : confirmedCount >= position.required_count;

                return (
                    <div
                        key={position.position_id}
                        className="position_applications_group"
                    >
                        <div className="position_group_header">
                            <h4>{position.role_label || position.role}</h4>
                            <span
                                className={`capacity_badge ${isFull ? "full" : ""}`}
                            >
                                Obsazeno: {position.confirmed_count ?? confirmedCount} /{" "}
                                {position.required_count ?? position.capacity}
                            </span>
                        </div>

                        {posApplications.length === 0 ? (
                            <p className="no_applications_text">
                                Zatím se na tuto pozici nikdo nepřihlásil.
                            </p>
                        ) : (
                            <div className="applications_list">
                                {posApplications.map((app) => (
                                    <div
                                        key={app.application_id}
                                        className={`application_row status_${app.status}`}
                                    >
                                        {/* Profil uchazeče */}
                                        <div className="applicant_info">
                                            <img
                                                src={
                                                    app.profile_image_url ||
                                                    "/assets/default_avatar.jpg"
                                                }
                                                alt={app.user_name}
                                                className="applicant_avatar"
                                            />
                                            <div className="applicant_details">
                                                <span className="applicant_name">
                                                    {app.user_name}
                                                </span>
                                                <div className="applicant_rating">
                                                    <Stars rating={app.user_rating || 0} />
                                                    <span>
                                                        {app.user_rating || "Bez hodnocení"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Status badge */}
                                        <div className="application_status">
                                            <span
                                                className={`badge ${STATUS_BADGE_CLASS[app.status] || "badge_pending"}`}
                                            >
                                                {app.status === "confirmed" ||
                                                app.status === "accepted"
                                                    ? "🟢 Potvrzeno"
                                                    : app.status === "rejected"
                                                    ? "🔴 Odmítnuto"
                                                    : "🟡 Čeká na vyřízení"}
                                            </span>
                                        </div>

                                        {/* Akční tlačítka */}
                                        <div className="application_actions">
                                            <button
                                                className="btn_action btn_chat"
                                                onClick={() => onOpenChat(app.user_id)}
                                                title="Otevřít chat"
                                            >
                                                <FontAwesomeIcon icon={faComment} />{" "}
                                                Chat
                                            </button>

                                            {app.status === "pending" && (
                                                <>
                                                    <button
                                                        className={`btn_action btn_confirm ${isFull ? "full_disabled" : ""}`}
                                                        onClick={() =>
                                                            onStatusChange(
                                                                app.application_id,
                                                                "confirmed",
                                                            )
                                                        }
                                                        disabled={isFull}
                                                        title={
                                                            isFull
                                                                ? "Pozice je již obsazená"
                                                                : undefined
                                                        }
                                                    >
                                                        <FontAwesomeIcon icon={faCheck} />{" "}
                                                        Potvrdit
                                                    </button>
                                                    <button
                                                        className="btn_action btn_reject"
                                                        onClick={() =>
                                                            onStatusChange(
                                                                app.application_id,
                                                                "rejected",
                                                            )
                                                        }
                                                    >
                                                        <FontAwesomeIcon icon={faXmark} />{" "}
                                                        Odmítnout
                                                    </button>
                                                </>
                                            )}

                                            {app.status === "confirmed" && (
                                                <button
                                                    className="btn_action btn_cancel"
                                                    onClick={() =>
                                                        onStatusChange(
                                                            app.application_id,
                                                            "rejected",
                                                        )
                                                    }
                                                >
                                                    Zrušit směnu
                                                </button>
                                            )}

                                            {app.status === "rejected" && (
                                                <button
                                                    className="btn_action btn_restore"
                                                    onClick={() =>
                                                        onStatusChange(
                                                            app.application_id,
                                                            "pending",
                                                        )
                                                    }
                                                >
                                                    <FontAwesomeIcon icon={faRotateLeft} />{" "}
                                                    Obnovit
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default JobApplicationsManager;
